import { Typography } from 'components/typography/typography-component';
import React from 'react';

export default function Releaselogfeature() {
  return (
    <div className="mb-[6rem] flex flex-col justify-center">
      <section className="flex flex-col justify-center p-3 lg:w-full lg:flex-row">
        <div className="mt-4 flex w-full flex-col items-center lg:w-1/2  lg:p-10">
          <div className="">
            <Typography
              variant="h4"
              className="text-center font-GTWalsheimPro font-extrabold text-[#27292C] sm:py-10 lg:py-2"
            >
              Standalone page
            </Typography>

            <p className=" text-center  font-avenir text-[13px] md:text-[14px] lg:text-[16px]">
              Public page with your own domain, custom appearance and SEO
              optimization
            </p>
            <div className="mt-10 flex justify-center rounded-xl bg-[#EEe0F7] p-10">
              <img
                className=" object-contain "
                src="/assets/Standalone.webp"
                alt="standalone graphic"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="container mx-auto my-24 flex justify-center">
        <div className="flex justify-center">
          <Typography className="text-center font-GTWalsheimPro text-3xl font-extrabold text-[#27292C] md:w-4/5 md:text-4xl">
            Increase product retention by updating users fast and easy
          </Typography>
        </div>
      </section>
      <section className="mt-24 flex flex-col-reverse  items-center self-center sm:my-16 md:mt-0 md:px-5 lg:my-4 lg:mt-0 lg:flex-row lg:px-0">
        <div className="flex w-full justify-center lg:w-1/2">
          <img
            className="mt-[15%] h-full object-contain sm:w-[50%] lg:w-[60%]"
            src="/assets/write-note.webp"
            alt="write notes Graphic"
          />
        </div>

        <div className="lg:w-1/2 lg:px-32">
          <Typography
            variant="h4"
            className="py-2 text-center font-GTWalsheimPro text-[#27292C] lg:text-left "
          >
            Write Release Notes in Minutes
          </Typography>
          <p className="text-center font-avenir text-[13px] md:text-[14px] lg:text-left lg:text-[16px]">
            Our easy to use CMS is designed to help you write, review and
            publish release notes in minutes.
          </p>
        </div>
      </section>

      <section className="mt-24 flex h-auto flex-col items-center sm:my-16 md:mt-0 md:px-5 lg:my-4 lg:mt-0 lg:flex-row lg:px-0">
        <div className="lg:w-1/2 lg:px-32">
          <Typography
            variant="h4"
            className="py-2 text-center font-GTWalsheimPro text-[#27292C] lg:text-left "
          >
            Customize the changelog to fit your UI
          </Typography>
          <p className="text-center font-avenir text-[13px] md:text-[14px] lg:text-left lg:text-[16px]">
            Use our editor to customize the both the standalone site and the in
            app-widget with your brand colors and style guide.
          </p>
        </div>
        <div className="flex w-full justify-center lg:w-1/2">
          <img
            className="mt-[15%] h-full object-contain sm:w-[50%] lg:w-[60%]"
            src="/assets/customize-notes.webp"
            alt="customize notes Graphic"
          />
        </div>
      </section>
    </div>
  );
}
